import React, { useState } from 'react'
import { InventoryTable } from './InventoryShared';

function StockListPage({ items, navigate }) {
    const [query, setQuery] = useState('');
    const [category, setCategory] = useState('All');
    const categories = ['All', 'Raw', 'Kitchen', 'Bar'];
    const rows = items.filter(item => {
        const matchesCategory = category === 'All' || item.category === category;
        const matchesQuery = item.name.toLowerCase().includes(query.toLowerCase()) || item.supplier.toLowerCase().includes(query.toLowerCase());
        return matchesCategory && matchesQuery;
    });

    return (
        <section className='inventory-panel inventory-table-panel full'>
            <div className='inventory-toolbar'>
                <span>Inventory Stock List</span>
                <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder='Search item or supplier...' />
            </div>
            <div className='inventory-filter-tabs'>
                {categories.map(item => <button key={item} className={category === item ? 'active' : ''} onClick={() => setCategory(item)}>{item}</button>)}
            </div>
            <InventoryTable
                columns={[
                    { key: 'image', label: 'Image' },
                    { key: 'name', label: 'Item Name' },
                    { key: 'stockLevel', label: 'Stock Level' },
                    { key: 'supplier', label: 'Supplier' },
                    { key: 'status', label: 'Status', badge: true },
                ]}
                rows={rows.map(item => ({ ...item, stockLevel: `${item.currentStock} ${item.unit}` }))}
                onEdit={() => navigate('/Inventory/item-details')}
                onView={() => navigate('/Inventory/item-details')}
            />
        </section>
    );
}

export default StockListPage
